import { render, staticRenderFns } from "./MaterialShipToUser.vue?vue&type=template&id=7bb9c8d2&"
import script from "./MaterialShipToUser.vue?vue&type=script&lang=ts&"
export * from "./MaterialShipToUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports